'use strict';

var results, isFr, data, data_inner, audioStr, imgStr, audioPath, imgPath, chartWidth, padding, w, h, r, rotation, oldrotation, rotation2, oldrotation2, picked, picked2, totalDuration, svg, container, vis, vis_inner, pie, arc, arcs, arcs_inner;

function initialize() {
    // get the image path
    audioStr = $('#chart').data('audio-url');
    imgStr = $('#chart').data('img-url');

    audioPath = audioStr.substring(0, audioStr.lastIndexOf('/')+1);
    imgPath = imgStr.substring(0, imgStr.lastIndexOf('/')+1);

    // get the container width set the width and height of the SVG circle
    chartWidth = $("#chart").width();

    // essential veriables
    padding = { top: 0, right: 0, bottom: 0, left: 0 };
    w = chartWidth - padding.left - padding.right;
    h = chartWidth - padding.top - padding.bottom;
    r = Math.min(w, h) / 2;
    rotation = 30;
    oldrotation = 30;
    rotation2 = 30;
    oldrotation2 = 30;
    picked = 100000;
    picked2 = 100000;
    totalDuration = 5000;

    svg = d3.select('#chart')
        .append("svg")
        .data([data])
        .attr("width", w + padding.left + padding.right)
        .attr("height", h + padding.top + padding.bottom);
    container = svg.append("g")
        .attr("class", "chartholder")
        .attr("transform", "translate(" + (w / 2 + padding.left) + "," + (h / 2 + padding.top) + ")");
    vis = container.append("g").attr("class", "main_circle");

    vis_inner = container
        .append("g").attr("class", "inner_circle")

    // set the initial position
    vis.transition()
        .duration(0)
        .attrTween("transform", rotTween);

    vis_inner.transition()
        .duration(0)
        .attrTween("transform", rotTween_inner);

    pie = d3.layout.pie().sort(null).value(function (d) { return 1; });
    // declare an arc generator function
    arc = d3.svg.arc().outerRadius(r);
    // select paths, use arc generator to draw
    arcs = vis.selectAll("g.slice")
        .data(pie)
        .enter()
        .append("g")
        .attr("class", "slice");

    // arc item
    arcs.append("path")
        .attr("fill", "#FFFAEF")
        .attr("d", function (d) { return arc(d); });

    // add the text and image to outer circle
    arcs.append("g").attr("transform", function (d) {
        d.innerRadius = 0;
        d.outerRadius = r;
        d.angle = (d.startAngle + d.endAngle) / 2;
        return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")translate(" + (d.outerRadius - 15) + ")";
    }).append("text")
        .attr("text-anchor", "end")
        .attr("class", "inner_text outer")
        .text(function (d, i) {
            return data[i].title;
        })

    // add image
    arcs.append("g").attr("transform", function (d) {
        d.innerRadius = 0;
        d.outerRadius = r;
        d.angle = (d.startAngle + d.endAngle) / 2;
        return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")translate(" + (d.outerRadius - 15) + ")";
    }).append("image")
        .attr({
            class: "outer_circle_img",
            'xlink:href': function (d, i) {
                return imgPath + data[i].image;
            }
        })

    pie = d3.layout.pie().sort(null).value(function (d) { return 1; });
    // declare an arc generator function
    arc = d3.svg.arc().outerRadius(r / 1.45);

    arcs_inner = vis_inner.selectAll("g.slice")
        .data(pie)
        .enter()
        .append("g")
        .attr("class", "slice");

    // add item to inner cirlce
    arcs_inner.append("path")
        .attr("fill", "#FFFAEF")
        .attr("d", function (d) { return arc(d); });

    // add the text
    arcs_inner.append("g").attr("transform", function (d) {
        d.innerRadius = 0;
        d.outerRadius = r / 1.45;
        d.angle = (d.startAngle + d.endAngle) / 2;
        return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")translate(" + (d.outerRadius - 40) + ")";
    }).append("text")
        .attr("text-anchor", "end")
        .attr("class", "inner_text")
        .text(function (d, i) {
            return data_inner[i].title;
        })

    // add the bold text
    arcs_inner.append("g").attr("transform", function (d) {
        d.innerRadius = 0;
        d.outerRadius = r / 1.45;
        d.angle = (d.startAngle + d.endAngle) / 2;
        return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")translate(" + (d.outerRadius - 20) + ")";
    }).append("text")
        .attr("text-anchor", "end")
        .attr("class", "inner_text font-weight-bold")
        .text(function (d, i) {
            return data_inner[i].title_bold;
        })

    // add image
    arcs_inner.append("g").attr("transform", function (d) {
        d.innerRadius = 0;
        d.outerRadius = r / 1.45;
        d.angle = (d.startAngle + d.endAngle) / 2;
        return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")translate(" + (d.outerRadius - 40) + ")";
    }).append("image")
        .attr({
            class: "outer_circle_img",
            'xlink:href': function (d, i) {
                return imgPath + data_inner[i].image;
            }
        })
}

function spin(d) {

    $(".spin_button").addClass("disabled");

    var ps = 360 / 6,
        rng = Math.floor((Math.random() * 1440) + 1800);

    rotation = (Math.round(rng / ps) * ps);

    picked = Math.round(6 - (rotation % 360) / ps) + 2;
    picked = picked >= 6 ? (picked % 6) : picked;

    rotation += 0 + Math.round(ps / 2);
    vis.transition()
        .duration(totalDuration)
        .attrTween("transform", rotTween)
        .each("end", function () {
            oldrotation = rotation;
        });


    // 6 are the circle items
    var ps2 = 360 / 6,
        rng2 = Math.floor((Math.random() * 1440) + 1800);

    rotation2 = (Math.round(rng2 / ps2) * ps2);

    picked2 = Math.round((rotation2 % 360) / ps2);
    picked2 = picked2 >= 6 ? (picked2 % 6) : picked2;


    rotation2 -= 150;
    vis_inner.transition()
        .duration(totalDuration)
        .attrTween("transform", rotTween_inner)
        .each("end", function () {
            oldrotation2 = rotation2;
        });

    // run show_result function to create and show the results
    show_result(data[picked].label.toLocaleUpperCase() + "+" + data_inner[picked2].label.toLocaleUpperCase());

    setTimeout(function () {
        $(".spin_button").removeClass("disabled")
    }, totalDuration);
}

// rotate animation to selected angle
function rotTween(to) {
    var i = d3.interpolate(oldrotation % 360, rotation);
    return function (t) {
        return "rotate(" + i(t) + ")";
    };
}

// rotate animation to selected angle
function rotTween_inner(to) {
    var i = d3.interpolate(oldrotation2 % 360, rotation2);
    return function (t) {
        return "rotate(-" + i(t) + ")";
    };
}

function show_result(id) {
    // fetch top images
    var topImages = id.toLowerCase().split("+");
    // top images
    $(".top_image_1").attr("src", imgPath + topImages[1] + ".png").css({ right: "-100px", opacity: 0, top: "100px" });
    $(".top_image_2").attr("src", imgPath + topImages[0] + ".png").css({ left: "-100px", opacity: 0, top: "100px" });
    // main stats image
    if (isFr) {
        $(".result_stats").attr("src", imgPath + "results_fr/" + results[id].image).css({ opacity: 0 });
    } else {
        $(".result_stats").attr("src", imgPath + "results/" + results[id].image).css({ opacity: 0 });
    }
    // title and text
    $(".result_title").text(results[id].title).css({ opacity: 0, top: "100px" });
    $(".result_dec").text(results[id].description).css({ opacity: 0 });

    const audio3 = new Audio(audioPath + "SpinningWheel.mp3");
    audio3.play();

    const audio2 = new Audio(audioPath + "WheelClick.mp3");
    audio2.play();

    // show result box
    setTimeout(function () {

        const audio = new Audio(audioPath + "WinFanfare.mp3");
        audio.play();

        setTimeout(function () {
            const audio2 = new Audio(audioPath + "WheelResult.mp3");
            audio2.play();
        }, 1000);

        setTimeout(function () {
            const audio2 = new Audio(audioPath + "SpinAgain.mp3");
            audio2.play();
        }, 5000);

        $("#result").addClass("show");
        $(".top_image_1").animate({
            opacity: 1
        }, 1000).animate({
            right: '0px',
        }, 2000).animate({
            top: 0
        }, 1500);

        setTimeout(function () {
            $(".top_image_1").addClass("boxShadowNone");
        }, 3500)

        $(".top_image_2").animate({
            opacity: 1
        }, 1000).animate({
            left: '0px'
        }, 2000).animate({
            top: 0
        }, 1500);

        $(".result_title").animate({
            opacity: 0
        }, 2500).animate({
            opacity: 1
        }, 500).animate({
            top: 0
        }, 1500);

        $(".result_dec, .result_stats").animate({
            opacity: 0
        }, 4500).animate({
            opacity: 1
        }, 500);


    }, (totalDuration + 200));
}

// spin again button click
$(".result_spin").click(function () {
    $("#result").removeClass("show");
    $(".top_image_1").removeClass("boxShadowNone");
    // setTimeout(function () {
    //    spin();
    // }, 200);
    const audio = new Audio(audioPath + "SpinAgain.mp3");
    audio.play();
})

const init = (resultsData, outerData, innerData, bool) => {
    results = resultsData;
    data = outerData;
    data_inner = innerData;
    isFr = bool;

    $('.spin_button').on('click', spin);

    initialize();
}

module.exports = {
    init: init
}
